import { ErrorBoundary } from 'react-error-boundary';
import { MissingEntity } from '#components/atoms/missing-entity/MissingEntity.tsx';
import { MissingRoleError, useRoleName } from '#hooks/useRoleName.ts';

type Props = {
  roleID: string;
  className?: string;
};

/**
 * Fetches and shows a role name, or the ID if the fetch fails
 */
export function RoleName(props: Props) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        if (error instanceof MissingRoleError) {
          return <MissingEntity entityId={error.entityId} />;
        }

        throw error;
      }}
    >
      <RoleNameInner {...props} />
    </ErrorBoundary>
  );
}

function RoleNameInner({ roleID, className }: Props) {
  const roleName = useRoleName(roleID);

  return <span className={className}>{roleName}</span>;
}
